<template>
  <v-card color="white" :style="totalsStyle" class="mr-6 mt-6">
    <v-card-title>
      {{$t('totals')}}
    </v-card-title>
    <v-card-text class="font-weight-bold pb-5 px-5">
      <v-row dense>
        <v-col>{{$t('expectedTons')}}</v-col>
        <v-col class="text-right">{{numberWithCommas(totals.expected, 3)}}</v-col>
      </v-row>
      <v-row dense>
        <v-col>{{$t('harvestedTons')}}</v-col>
        <v-col class="text-right">{{numberWithCommas(totals.harvested, 3)}}</v-col>
      </v-row>
      <v-row dense>
        <v-col>{{$t('remainingTons')}}</v-col>
        <v-col class="text-right">{{numberWithCommas(totals.remaining, 3)}}</v-col>
      </v-row>
      <v-row dense>
        <v-col>{{$t('overcutTons')}}</v-col>
        <v-col class="text-right">{{numberWithCommas(totals.overcut, 3)}}</v-col>
      </v-row>
      <v-row v-if="totals.expectedMBF > 0" dense>
        <v-col>{{$t('expectedMBF')}}</v-col>
        <v-col class="text-right">{{numberWithCommas(totals.expectedMBF, 3)}}</v-col>
      </v-row>
      <v-row v-if="totals.expectedMBF > 0" dense>
        <v-col>{{$t('harvestedMBF')}}</v-col>
        <v-col class="text-right">{{numberWithCommas(totals.harvestedMBF, 3)}}</v-col>
      </v-row>
      <v-row v-if="totals.expectedMBF > 0" dense>
        <v-col>{{$t('remainingMBF')}}</v-col>
        <v-col class="text-right">{{numberWithCommas(totals.remainingMBF, 3)}}</v-col>
      </v-row>
      <v-row v-if="totals.expectedMBF > 0" dense>
        <v-col>{{$t('overcutMBF')}}</v-col>
        <v-col class="text-right">{{numberWithCommas(totals.overcutMBF, 3)}}</v-col>
      </v-row>
      <v-row dense>
        <v-col>{{$t('cruisedValue')}}</v-col>
        <v-col class="text-right">{{formatMoney(totals.cruisedValue)}}</v-col>
      </v-row>
      <v-row dense>
        <v-col>{{$t('cost')}}</v-col>
        <v-col class="text-right">{{formatMoney(totals.tractCost)}}</v-col>
      </v-row>
      <v-row dense>
        <v-col>{{$t('stumpageValue')}}</v-col>
        <v-col class="text-right">{{formatMoney(totals.stumpageValue)}}</v-col>
      </v-row>
      <v-row dense>
        <v-col>{{$t('averageCutoutValue')}}</v-col>
        <v-col class="text-right">{{formatMoney(totals.cutoutValue)}}</v-col>
      </v-row>
      <v-row dense>
        <v-col>{{ $t('costBalance') }}</v-col>
        <v-col class="text-right">{{ formatMoney(totals.costBalance) }}</v-col>
      </v-row>
      <v-row dense>
        <v-col>{{ $t('depletionBalance') }}</v-col>
        <v-col class="text-right">{{ formatMoney(totals.depletionBalance) }}</v-col>
      </v-row>
    </v-card-text>
  </v-card>
  </template>

<script>
import { formatMoney, numberWithCommas } from '@/utils/NumericMutations.js'

export default {
  props: {
    totals: {
      type: Object,
      required: true
    }
  },

  computed: {
    totalsStyle () {
      return {
        width: 'max(256px, min(330px, 100vw))'
      }
    }
  },

  methods: {
    formatMoney,
    numberWithCommas
  }
}
</script>
